import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { toast } from '../../../utils'

import { StoresContext } from '../../../provider/StoreProvider'
import { BottomSheetContext } from '../../../provider/bottomSheetProvider'

import { BankIcon } from '../../../components/bankIcon'
import { BottomSheet } from '../../../components/bottomSheet'
import { SecurityIcon } from '../../../components/securityIcon'
import { Text } from '../../../components/text'
import type { BankName } from '../../../components/bankIcon/BankIcon'
import type { SecurityName } from '../../../components/securityIcon/SecurityIcon'

import { Color } from '../../../theme/color'

// TODO: 지워야함
interface APIResponse {
  bank: { code: string; name: BankName }[]
  securities: { code: string; name: SecurityName }[]
}

type TabId = 'bank' | 'securities'

interface WithdrawalAccountBottomSheet {
  onSelect: (withdrawalAccount: (APIResponse['bank'][0] | APIResponse['securities'][0]) & { type: TabId }) => void
}

export function WithdrawalAccountBottomSheet({ onSelect }: WithdrawalAccountBottomSheet) {
  const { myStore } = useContext(StoresContext)
  const { hideBottomSheet } = useContext(BottomSheetContext)

  const [list, setList] = useState<APIResponse['bank'] | APIResponse['securities']>([])
  const [activeTab, setActiveTab] = useState<TabId>('bank')

  const getBanks = async (activeTab: TabId) => {
    try {
      const response = await myStore.getWithdrawalBankList()
      setList(activeTab === 'bank' ? response.bank : response.securities)
    } catch (err: unknown) {
      toast('은행 리스트를 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요!', err)
    }
  }

  useEffect(() => {
    getBanks(activeTab)
  }, [activeTab])

  return (
    <BottomSheet $height="calc(100% - 192px)">
      {/* TODO: Tab component 변경해야함 */}
      <TabContainer>
        <Tab isActive={activeTab === 'bank'} onClick={() => setActiveTab('bank')}>
          <Text size={20} weight={600}>
            은행
          </Text>
        </Tab>
        <Tab isActive={activeTab === 'securities'} onClick={() => setActiveTab('securities')}>
          <Text size={20} weight={600}>
            증권
          </Text>
        </Tab>
      </TabContainer>
      <List>
        {list.map((info) => {
          const { code, name } = info
          const select = () => {
            onSelect({ ...info, type: activeTab })
            hideBottomSheet()
          }
          return (
            <Item key={code} onClick={select}>
              {activeTab === 'bank' && <BankIcon size={30} name={name as BankName} />}
              {activeTab === 'securities' && <SecurityIcon size={30} name={name as SecurityName} />}
              <Text size={14}>{name}</Text>
            </Item>
          )
        })}
        <div style={{ height: 'env(safe-area-inset-bottom)' }} />
      </List>
    </BottomSheet>
  )
}

const TabContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 32px 24px 0;
  border-bottom: 1px solid ${Color.line};
`

const Tab = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  padding-bottom: 6px;
  ${({ isActive }) =>
    isActive
      ? `
        border-bottom: 2px solid ${Color.text_primary};
      `
      : `
        border-bottom: 2px solid transparent;
        > span {
          color: ${Color.gray_4};
        }
      `}
`

const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px;
  overflow-y: auto;
  padding: 16px 24px;
  @media (max-width: 340px) {
    grid-template-columns: 1fr 1fr;
  }
`

const Item = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  border-radius: 8px;
  background-color: ${Color.gray_1};
  list-style: none;
`
